import { validator } from "@/utils/validator";
import { useMemo } from "react";
import { MAX_CHARACTER_EMAIL_VALIDATION, MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { TUserActiveStatus, USER_ACTIVE_STATUS } from "@/types/enum";

export const useGetCompanyUserSchema = () => {
  const companyUserSchema = useMemo(() => {
    return validator.object().shape({
      fullName: validator
        .string()
        .trim()
        .emptyToNull()
        .label("ユーザー名")
        .max(MAX_CHARACTER_INPUT_VALIDATION)
        .required(),
      email: validator.string().trim().email().label("メールアドレス").required().max(MAX_CHARACTER_EMAIL_VALIDATION),
      activeStatus: validator.mixed<TUserActiveStatus>().oneOf(Object.values(USER_ACTIVE_STATUS)).label("ステータス").required(),
    });



  }, []);

  return { companyUserSchema };
};
